import React from 'react';
import { InputAdornment } from '@mui/material';

import { TextField, TextFieldProps } from './TextField';

export type CurrencyInputFieldProps = TextFieldProps;

export const CurrencyInputField = React.forwardRef<HTMLDivElement, CurrencyInputFieldProps>(
  (props, ref) => {
    return (
      <TextField
        type='number'
        {...props}
        InputProps={{
          startAdornment: <InputAdornment position='start'>$</InputAdornment>,
          ...props.InputProps,
        }}
        inputProps={{
          ...props.inputProps,
          step: '0.01',
        }}
        ref={ref}
      />
    );
  },
);
